import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

/**
 * SafeUrlPipe
 */
@Pipe({
    name: 'safeUrl',
})
export class SafeUrlPipe implements PipeTransform {
    /**
     * Constructor
     *
     * @param sanitizer DomSanitizer
     */
    constructor(private sanitizer: DomSanitizer) {}

    /**
     * Implementation
     *
     * @param url
     */
    transform(url: string, type?: 'url' | 'resource'): SafeUrl | SafeResourceUrl {

        return type === 'resource' ?
         this.sanitizer.bypassSecurityTrustResourceUrl(url) :
            this.sanitizer.bypassSecurityTrustUrl(url);
    }
}
